var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0775 21H21.9225M6 11.6899V16.8622M12 11.6899V16.8622M18 11.6899V16.8622M2.0775 8.05083H21.9225C22.8843 8.05083 14.6171 4.11475 12.4908 3.10985C12.1809 2.96338 11.8191 2.96338 11.5092 3.10985C9.3829 4.11475 1.11574 8.05083 2.0775 8.05083Z",
    stroke: "#3545DE",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.1ae4282b0d41067d51b44990957c2061.svg";
export { ForwardRef as ReactComponent };